import { render, staticRenderFns } from "./selectPopover.vue?vue&type=template&id=bbdd8cde"
import script from "./selectPopover.vue?vue&type=script&lang=js"
export * from "./selectPopover.vue?vue&type=script&lang=js"
import style0 from "./selectPopover.vue?vue&type=style&index=0&id=bbdd8cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports